:root[data-theme='dark'] {
  astral-pane {
    background: #353535;
  }
}

astral-pane {
  display: block;
  background: #fff;
  padding: 15px;
  border-radius: 15px;

  &[raised] {
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24);
  }

  &[stroked] {
    border: 1px solid var(--astral-text-color);
  }

  [slot='content'] {
    color: var(--astral-text-color);
  }

  h1[slot='title'] {
    margin: 0;
    font-family: var(--astral-secondary-font);
    font-size: 1.5em;
  }
  h2[slot='title'] {
    margin: 0;
    font-family: var(--astral-secondary-font);
    font-size: 1.25em;
  }
  h3[slot='title'] {
    margin: 0;
    font-family: var(--astral-secondary-font);
    font-size: 1em;
  }

  p[slot='content'] {
    margin: 0;
    font-family: var(--astral-primary-font);
  }
}
